import React, { useState } from "react";
import TextInput from "../../components/ui/inputs/TextInput";
import AddressInput from "../../components/ui/inputs/AddressInput";
import { useOutletContext, useParams } from "react-router-dom";
import Button from "../../components/ui/Button";
import { toast } from "react-toastify";
import { updateEnterprise } from "../../services/api/bidderService";
import SpinnerIcon from "../../assets/icons/spinner";

export default function Legal() {
    const { bidder, handleUpdateProcurement, procurement } = useOutletContext();
    const { uuidEnterprise } = useParams();
    const [isUpdating, setIsUpdating] = useState(false);

    const [name, setName] = useState(bidder.name || "");
    const [bce, setBce] = useState(bidder.enterpriseNumber || "");
    const [legalForm, setLegalForm] = useState(bidder.legalForm || "");
    const [address, setAddress] = useState({
        street: bidder.rawStreet,
        postalCode: bidder.postalCode,
        city: bidder.locality,
        country: bidder.country,
    });

    const countries = [
        { value: "Belgique", label: "Belgique" },
        { value: "France", label: "France" },
        { value: "Allemagne", label: "Allemagne" },
        { value: "Pays-Bas", label: "Pays-Bas" },
        { value: "Luxembourg", label: "Luxembourg" },
    ];

    function validateFields() {
        let validationErrors = [];

        if (!name.trim()) validationErrors.push("Le nom de l'entité est obligatoire.");
        if (!bce.trim()) validationErrors.push("Le numéro BCE est obligatoire.");
        if (!legalForm.trim()) validationErrors.push("La forme juridique est obligatoire.");

        if (!address.street || !address.postalCode || !address.city || !address.country) {
            validationErrors.push("L'adresse complète est obligatoire.");
        }

        return validationErrors.length === 0;
    }

    async function handleUpdate() {
        try {
            setIsUpdating(true);
            if (validateFields()) {
                const updatedBidder = {
                    name: name,
                    enterpriseNumber: bce,
                    legalForm: legalForm,
                    rawStreet: address.street,
                    postalCode: address.postalCode,
                    locality: address.city,
                    country: address.country,
                };

                await updateEnterprise(uuidEnterprise, updatedBidder);
                await handleUpdateProcurement();
                toast.success("Les informations ont été mises à jour avec succès !");
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsUpdating(false);
        }
    }

    function canEdit() {
        return procurement.canWrite;
    }

    return (
        <>
            <div className="flex flex-col space-y-6 md:w-1/2 lg:w-4/5">
                <TextInput id="bce" label="Numéro BCE" value={bce} onChange={setBce} disabled />
                <TextInput id="name" label="Nom de l'entité" value={name} onChange={setName} disabled={!canEdit()} required />
                <TextInput id="legalForm" label="Forme juridique" value={legalForm} onChange={setLegalForm} disabled={!canEdit()} required />
                <AddressInput address={address} countries={countries} onChange={setAddress} disabled={!canEdit()} required />
                {canEdit() && (
                    <div className="flex items-center gap-2">
                        <Button color="blue" onClick={handleUpdate} disabled={!validateFields() || isUpdating}>
                            Modifier
                        </Button>
                        {isUpdating && (
                            <div className="w-10">
                                <SpinnerIcon />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </>
    );
}
